module.exports = __webpack_public_path__ + "img/bifold-easel.96891be2.svg";